// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"m9sEjK5d","error":"_1pnSltrr","tooltipArrow":"ONK7vLxs"};